import {
  Directive,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output, SimpleChanges
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
  selector: '[contenteditableModel]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ContenteditableModelDirective),
    multi: true
  }]
})
export class ContenteditableModelDirective implements ControlValueAccessor, OnInit, OnChanges {
  @Input() contenteditableModel: string | undefined;
  @Output() contenteditableModelChange = new EventEmitter<string>();
  private onChange: Function = () => {};
  private onTouched: Function = () => {};

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.writeValue(this.contenteditableModel);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contenteditableModel']) {
      this.writeValue(this.contenteditableModel);
    }
  }

  @HostListener('input') onInput() {
    const value = this.el.nativeElement.innerHTML;
    this.onChange(value);
    this.contenteditableModelChange.emit(value);
  }

  @HostListener('blur') onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value === null || value === undefined) {
      value = '';
    }

    if (value !== this.el.nativeElement.innerHTML) {
      this.el.nativeElement.innerHTML = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.contentEditable = !isDisabled;
  }

}
